import { DynamicGroup, IDynamicGroupOptions } from "../dynamic-group.model";

export interface ICalculatedGroupOptions extends IDynamicGroupOptions { }

export abstract class CalculatedGroup extends DynamicGroup implements ICalculatedGroupOptions {
  constructor(options: ICalculatedGroupOptions = {}) {
    super(options);
  }
}
